import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UserApiService } from 'src/app/services/api/user-api.service';

@Component({
  selector: 'app-gocaptcha',
  templateUrl: './gocaptcha.component.html',
  styleUrls: ['./gocaptcha.component.scss'],
})
export class GocaptchaComponent implements OnInit {
  constructor(
    private api: UserApiService,
    private message: NzMessageService,
    private dialogRef: MatDialogRef<GocaptchaComponent>
  ) {}

  ngOnInit(): void {
    this.getCaptcha();
  }

  /* 松手自动验证 */
  onDragEnd(x: number) {
    if (x <= 0 || this.loading) return;
    this.sliderX = x;
    this.verifyCaptcha();
  }

  async verifyCaptcha() {
    if (this.loading) return;
    try {
      this.loading = true;
      const r = await this.api.verifyCaptcha(this.sliderX);
      if (r.status === 11007) {
        this.message.warning('验证失败，请重试');
      } else if (r.status !== 0) {
        this.message.warning('未知错误');
      } else {
        if (!r.data) {
          this.message.warning('验证失败，请重试');
        } else {
          this.message.success('验证成功');
          this.dialogRef.close(true);
        }
      }
    } catch (error) {
      this.message.error('网络错误');
    } finally {
      this.loading = false;
    }
  }

  reset() {
    this.getCaptcha();
  }

  data: any = null;
  loading = false;
  async getCaptcha() {
    this.data = null;
    if (this.loading) return;
    try {
      this.loading = true;
      const r = await this.api.getCaptcha();
      this.data = r.data;
    } catch (error) {
      this.message.error('网络错误');
    } finally {
      this.loading = false;
    }
  }

  sliderX = 0;
  onSliderXChanged(x: number) {
    this.sliderX = x;
  }
}
